var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prescription_entry"},[(_vm.showInfo)?_c('patient-info-1',{attrs:{"pageType":_vm.pageType,"info":_vm.info}}):_vm._e(),_c('div',{staticClass:"prescription_entry_body"},[_c('prescription-input',{attrs:{"pageType":_vm.pageType,"info":_vm.info,"quoteDurgList":_vm.quoteDurgList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }